function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m296 8h144c17.671875 0 32 14.328125 32 32v144c0 17.671875-14.328125 32-32 32h-144c-17.671875 0-32-14.328125-32-32v-144c0-17.671875 14.328125-32 32-32zm0 0",
  fill: "#bddbff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m40 8h144c17.671875 0 32 14.328125 32 32v144c0 17.671875-14.328125 32-32 32h-144c-17.671875 0-32-14.328125-32-32v-144c0-17.671875 14.328125-32 32-32zm0 0",
  fill: "#bddbff"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m296 264h144c17.671875 0 32 14.328125 32 32v144c0 17.671875-14.328125 32-32 32h-144c-17.671875 0-32-14.328125-32-32v-144c0-17.671875 14.328125-32 32-32zm0 0",
  fill: "#bddbff"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m40 264h144c17.671875 0 32 14.328125 32 32v144c0 17.671875-14.328125 32-32 32h-144c-17.671875 0-32-14.328125-32-32v-144c0-17.671875 14.328125-32 32-32zm0 0",
  fill: "#bddbff"
});

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#3d9ae2"
}, React.createElement("path", {
  d: "m80 224c3.25.019531 6.1875-1.929688 7.433594-4.933594 1.246094-3 .554687-6.457031-1.753906-8.746094-2.300782-2.269531-5.742188-2.933593-8.71875-1.679687-.980469.386719-1.875.957031-2.640626 1.679687-3.09375 3.15625-3.09375 8.203126 0 11.359376.765626.722656 1.660157 1.292968 2.640626 1.679687.960937.410156 1.992187.628906 3.039062.640625zm0 0"
}), React.createElement("path", {
  d: "m184 0h-144c-22.082031.0273438-39.9726562 17.917969-40 40v144c.0273438 22.082031 17.917969 39.972656 40 40h16c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-16c-13.253906 0-24-10.746094-24-24v-144c0-13.253906 10.746094-24 24-24h144c13.253906 0 24 10.746094 24 24v144c0 13.253906-10.746094 24-24 24h-80c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8h80c22.082031-.027344 39.972656-17.917969 40-40v-144c-.027344-22.082031-17.917969-39.9726562-40-40zm0 0"
}), React.createElement("path", {
  d: "m440 0h-144c-22.082031.0273438-39.972656 17.917969-40 40v144c.027344 22.082031 17.917969 39.972656 40 40h144c22.082031-.027344 39.972656-17.917969 40-40v-144c-.027344-22.082031-17.917969-39.9726562-40-40zm24 184c0 13.253906-10.746094 24-24 24h-144c-13.253906 0-24-10.746094-24-24v-144c0-13.253906 10.746094-24 24-24h144c13.253906 0 24 10.746094 24 24zm0 0"
}), React.createElement("path", {
  d: "m440 256h-144c-22.082031.027344-39.972656 17.917969-40 40v144c.027344 22.082031 17.917969 39.972656 40 40h144c22.082031-.027344 39.972656-17.917969 40-40v-144c-.027344-22.082031-17.917969-39.972656-40-40zm24 184c0 13.253906-10.746094 24-24 24h-144c-13.253906 0-24-10.746094-24-24v-144c0-13.253906 10.746094-24 24-24h144c13.253906 0 24 10.746094 24 24zm0 0"
}), React.createElement("path", {
  d: "m184 256h-144c-22.082031.027344-39.9726562 17.917969-40 40v144c.0273438 22.082031 17.917969 39.972656 40 40h144c22.082031-.027344 39.972656-17.917969 40-40v-144c-.027344-22.082031-17.917969-39.972656-40-40zm24 184c0 13.253906-10.746094 24-24 24h-144c-13.253906 0-24-10.746094-24-24v-144c0-13.253906 10.746094-24 24-24h144c13.253906 0 24 10.746094 24 24zm0 0"
}));

var SvgTileset = function SvgTileset(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: "480pt",
    viewBox: "0 0 480 480",
    width: "480pt",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTileset, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tileset.484ef6e0.svg";
export { ForwardRef as ReactComponent };